export const CA = {
  "Open document": "Obre el document",
  "Upload file": "Penja el document",
  "Drop file here to upload": "Deixa anar el fitxer aquÃ­ per penjar-lo",
  "Disc": "Disc",
  "URL": "URL",
  "FILE": "DOSSIER",
  "SIZE": "TALLA",
  "MB": "MB",
  "KB": "KB",
  "Bytes": "Bytes",
  "Loading... Please wait.": "Carregant, esperi, si us plau.",
  "Fit Width": "Amplada dâajust",
  "Fit Height": "Ajust de l'alÃ§ada",
  "Password protected document": "Document protegit amb contrasenya",
  "Password": "Contrasenya",
  "Open": "Obert",
  "Password Required": "Es requereix una contrasenya",
  "Incorrect password": "contrasenya incorrecta",
  "Error": "Error",
  "Something went wrong": "Alguna cosa ha anat malament",
  "Server is not available": "El servidor no estÃ  disponible",
  "of": "de",
  "Please wait...": "Si us plau, espereu ..."
};
